export default __webpack_public_path__ + "static/media/MLB.393fffa1.png";